<template>
  <div>
    <!-- <div class="row align">
      <div class="col-4">
       
      </div>
    </div> -->
    <div class="image-container">
      <img :src="logo" class="logo-image" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Logo",

  data() {
    return {
      tenantData: [],
      userData: localStorage.getItem("userData"),
    };
  },

  computed: {
    logo() {
      const userData = localStorage.getItem("userData");
      if (userData) {
        const imageUrl = JSON.parse(userData).imageUrl;
        // const url = process.env.VUE_APP_MAIN_URL.replace('api/v1/','');
        // return url + imageUrl;
        let fileType = imageUrl.endsWith('.png') ? 'png' : 'jpeg';
        const tenantLogo = JSON.parse(userData).tenantLogo;
        return "data:image/${fileType};base64," + tenantLogo;
      } else {
        // Replace with default logo if user data is not found
        return `../../assets/images/logo/logo.svg`;
      }
    },
  },

  mounted() {
    this.tenantData = JSON.parse(localStorage.getItem("userData"));
  },
};
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "~@core/scss/base/components/variables-dark";

.image-container {
  display: flex;
  justify-content: center; 
  align-items: center;
}

.logo-image {
  width:75px;  
  height: auto; 
  max-width: 100%; 
  object-fit: contain; 
}

@media (max-width: 768px) {
  .logo-image {
    width:50px;
  }
}
</style>
